export default __webpack_public_path__ + "static/index_data_bg_tn-e1a46b9dd33d3a9de1942e8104585dce.png";